import { Component } from '@angular/core';
import { NotificationService } from 'src/app/services/notification.service';
import { UploadService } from 'src/app/services/upload.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { Apierror, ErrorObject } from '../../models/error.model';

@Component({
    selector: 'app-refresh_dataset',
    templateUrl: 'refresh_dataset.component.html',
    styleUrls: ['refresh_dataset.component.css'],
    standalone: false
})
export class Refresh_datasetComponent {
  constructor(private uploadService: UploadService,
    private toast: NotificationService,
    private loader: LoaderService) {
  }

  refreshData() {
    this.loader.start();
    this.uploadService.refreshDataSet().subscribe(res => {
      this.loader.stop();
      this.toast.showSuccess("Reports refreshing initiated successfully.");
    },
      (errorInfo: any) => {
        this.loader.stop();
        this.toast.showException(errorInfo.error);
        // let error: ErrorObject = new ErrorObject();
        // error.apierror = new Apierror();
        // error.apierror.message = "Report refresh in progress, Please maintain 5 minutes gap for every Refresh.";
        // this.toast.showException(error);
      });
  }
}
